/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateBankSuffixToPlaidMask} from '../api'

export const useMutationUpdateBankSuffixToPlaidMask = createReactQueryMutationHook('updateBankSuffixToPlaidMask', updateBankSuffixToPlaidMask)
